import { render, staticRenderFns } from "./see_pop.vue?vue&type=template&id=205045a8&"
import script from "./see_pop.vue?vue&type=script&lang=js&"
export * from "./see_pop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports